export default __webpack_public_path__ + "static/media/PRODUCT.4cf0d5c0.png";